import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

// Interfaces
import type { User } from '../../interfaces/user';

const DUMMY_USER: User = {
  id: 'local_user',
  display_name: 'Local User',
  email: 'local@example.com',
  country: 'US',
  images: [
    { url: 'https://i.pravatar.cc/150?img=11', width: 150, height: 150 },
    { url: 'https://i.pravatar.cc/150?img=11', width: 300, height: 300 }
  ],
  product: 'premium',
  type: 'user',
  uri: 'spotify:user:local_user',
  followers: { total: 0, href: null },
  external_urls: { spotify: '' },
  href: ''
};

const initialState: { token?: string; playerLoaded: boolean; user?: User; requesting: boolean } = {
  user: DUMMY_USER,
  requesting: false,
  playerLoaded: true,
  token: 'dummy_token',
};

export const loginToSpotify = createAsyncThunk<{ token?: string; loaded: boolean }>(
  'auth/loginToSpotify',
  async () => {
    return { token: 'dummy_token', loaded: true };
  }
);

export const fetchUser = createAsyncThunk('auth/fetchUser', async () => {
  return DUMMY_USER;
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRequesting(state, action: PayloadAction<{ requesting: boolean }>) {
      state.requesting = action.payload.requesting;
    },
    setToken(state, action: PayloadAction<{ token?: string }>) {
      state.token = action.payload.token;
    },
    setPlayerLoaded(state, action: PayloadAction<{ playerLoaded: boolean }>) {
      state.playerLoaded = action.payload.playerLoaded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginToSpotify.fulfilled, (state, action) => {
      state.token = action.payload.token;
      state.requesting = !action.payload.loaded;
    });
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.requesting = false;
    });
  },
});

export const authActions = { ...authSlice.actions, loginToSpotify, fetchUser };

export default authSlice.reducer;
